(() => {
  /**
   * Portadas por tarjeta. NO corre en el editor de Shopify (congela el preview).
   */
  if (window.Shopify && Shopify.designMode) return;
  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  const root = document.querySelector('[data-chikas-silhouettes]');
  if (!root) return;

  const cards = [...root.querySelectorAll('[data-silhouette-filter]')];
  if (!cards.length) return;

  const needsCover = cards.filter((el) => {
    if (!el.classList.contains('silhouette--empty') && el.querySelector('img[src]')) return false;
    return true;
  });
  if (!needsCover.length) return;

  const norm = (s) =>
    String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[-_]/g, ' ')
      .trim();

  const aliases = {
    palazzo: ['palazzo', 'palazo'],
    palazo: ['palazzo', 'palazo'],
    basic: ['basic', 'basico'],
    basico: ['basic', 'basico'],
    'wide leg': ['wide leg', 'wideleg'],
    'mom fit': ['mom fit', 'momfit'],
    'bota campana': ['bota campana'],
  };

  const tagList = (product) => {
    const raw = product.tags;
    if (Array.isArray(raw)) return raw.map(norm);
    return String(raw || '')
      .split(',')
      .map((t) => norm(t))
      .filter(Boolean);
  };

  const matchesFilter = (product, filterRaw) => {
    const filter = norm(filterRaw);
    if (!filter || filter.length < 3) return false;
    const keys = aliases[filter] || [filter];
    const title = norm(product.title);
    const type = norm(product.product_type || product.type);
    const handle = norm(product.handle).replace(/\s+/g, '-');
    const tags = tagList(product);

    return keys.some((k) => {
      const kk = norm(k);
      if (!kk) return false;
      const re = new RegExp(`(^|[^a-z0-9])${kk.replace(/\s+/g, '[\\s-]*')}([^a-z0-9]|$)`, 'i');
      if (re.test(title)) return true;
      if (type === kk || re.test(type)) return true;
      if (tags.some((t) => t === kk || re.test(t))) return true;
      const handleKey = kk.replace(/\s+/g, '-');
      if (handle === handleKey || handle.includes(handleKey)) return true;
      return false;
    });
  };

  const imageFromProduct = (product) => {
    const img = product.images?.[0] || product.featured_image || product.image || null;
    if (!img) return '';
    if (typeof img === 'string') return img.startsWith('//') ? `https:${img}` : img;
    const src = img.src || img.url || '';
    return src.startsWith('//') ? `https:${src}` : src;
  };

  const fetchAllProducts = async () => {
    const all = [];
    const limit = 250;
    // Máx 8 páginas (= 2000 productos) para no colgar la tienda
    for (let page = 1; page <= 8; page += 1) {
      const res = await fetch(`/collections/all/products.json?limit=${limit}&page=${page}`, {
        credentials: 'same-origin',
      });
      if (!res.ok) break;
      const data = await res.json();
      const batch = data.products || [];
      if (!batch.length) break;
      all.push(...batch);
      if (batch.length < limit) break;
    }
    return all;
  };

  const applyCover = (card, product) => {
    let src = imageFromProduct(product);
    if (!src) return false;
    if (src.includes('cdn.shopify.com') && !src.includes('_900x') && !src.includes('width=')) {
      src = src.replace(/(\.(jpg|jpeg|png|webp))(\?|$)/i, '_900x$1$3');
    }
    let img = card.querySelector('img');
    const placeholder = card.querySelector('.silhouette__placeholder');
    if (!img) {
      img = document.createElement('img');
      img.loading = 'lazy';
      img.alt = card.dataset.silhouetteTitle || product.title || '';
      card.insertBefore(img, card.firstChild);
    }
    img.src = src;
    card.classList.remove('silhouette--empty');
    if (placeholder) placeholder.remove();
    return true;
  };

  // Diferir para no bloquear el primer paint
  const run = async () => {
    try {
      const products = await fetchAllProducts();
      needsCover.forEach((card) => {
        const title = norm(card.dataset.silhouetteTitle);
        const filter = norm(card.dataset.silhouetteFilter);
        let key = title || filter;
        if (filter && title && filter !== title) {
          if ((filter === 'palazzo' || filter === 'palazo') && title !== 'palazzo' && title !== 'palazo') {
            key = title;
          } else {
            key = filter;
          }
        }
        const matches = products.filter((p) => matchesFilter(p, key));
        let pool = matches;
        // Basic: solo jeans Basic del inventario (evitar falsos como Camisa)
        if (key === 'basic' || key === 'basico') {
          const preferred = matches.filter((p) => {
            const t = norm(p.title);
            const ty = norm(p.product_type || p.type);
            return (
              /\bjean\s+basic\b/.test(t) ||
              /\bbasic\s+dama\b/.test(ty) ||
              (ty.includes('basic') && t.includes('jean'))
            );
          });
          if (preferred.length) pool = preferred;
        }
        const pick = pool.find((p) => p.available !== false) || pool[0];
        if (pick) applyCover(card, pick);
      });
    } catch (err) {
      console.warn('[chikas-silhouettes] covers', err);
    }
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => run(), { timeout: 2500 });
  } else {
    window.setTimeout(run, 400);
  }
})();
